(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode('/*! tailwindcss v4.1.11 | MIT License | https://tailwindcss.com */@layer properties{@supports (((-webkit-hyphens:none)) and (not (margin-trim:inline))) or ((-moz-orient:inline) and (not (color:rgb(from red r g b)))){*,:before,:after,::backdrop{--tw-translate-x:0;--tw-translate-y:0;--tw-translate-z:0;--tw-border-style:solid;--tw-leading:initial;--tw-font-weight:initial}}}@layer theme{:root,:host{--db-font-sans:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";--db-font-mono:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;--db-color-black:#000;--db-color-white:#fff;--db-spacing:.25rem;--db-text-xs:.75rem;--db-text-xs--line-height:calc(1/.75);--db-text-base:1rem;--db-text-base--line-height: 1.5 ;--db-text-lg:1.125rem;--db-text-lg--line-height:calc(1.75/1.125);--db-font-weight-bold:700;--db-default-font-family:var(--db-font-sans);--db-default-mono-font-family:var(--db-font-mono)}}@layer base{*,:after,:before,::backdrop{box-sizing:border-box;border:0 solid;margin:0;padding:0}::file-selector-button{box-sizing:border-box;border:0 solid;margin:0;padding:0}html,:host{-webkit-text-size-adjust:100%;tab-size:4;line-height:1.5;font-family:var(--db-default-font-family,ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji");font-feature-settings:var(--db-default-font-feature-settings,normal);font-variation-settings:var(--db-default-font-variation-settings,normal);-webkit-tap-highlight-color:transparent}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;-webkit-text-decoration:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:var(--db-default-mono-font-family,ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace);font-feature-settings:var(--db-default-mono-font-feature-settings,normal);font-variation-settings:var(--db-default-mono-font-variation-settings,normal);font-size:1em}small{font-size:80%}sub,sup{vertical-align:baseline;font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}:-moz-focusring{outline:auto}progress{vertical-align:baseline}summary{display:list-item}ol,ul,menu{list-style:none}img,svg,video,canvas,audio,iframe,embed,object{vertical-align:middle;display:block}img,video{max-width:100%;height:auto}button,input,select,optgroup,textarea{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}::file-selector-button{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}:where(select:is([multiple],[size])) optgroup{font-weight:bolder}:where(select:is([multiple],[size])) optgroup option{padding-inline-start:20px}::file-selector-button{margin-inline-end:4px}::placeholder{opacity:1}@supports (not ((-webkit-appearance:-apple-pay-button))) or (contain-intrinsic-size:1px){::placeholder{color:currentColor}@supports (color:color-mix(in lab,red,red)){::placeholder{color:color-mix(in oklab,currentcolor 50%,transparent)}}}textarea{resize:vertical}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-date-and-time-value{min-height:1lh;text-align:inherit}::-webkit-datetime-edit{display:inline-flex}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-datetime-edit{padding-block:0}::-webkit-datetime-edit-year-field{padding-block:0}::-webkit-datetime-edit-month-field{padding-block:0}::-webkit-datetime-edit-day-field{padding-block:0}::-webkit-datetime-edit-hour-field{padding-block:0}::-webkit-datetime-edit-minute-field{padding-block:0}::-webkit-datetime-edit-second-field{padding-block:0}::-webkit-datetime-edit-millisecond-field{padding-block:0}::-webkit-datetime-edit-meridiem-field{padding-block:0}:-moz-ui-invalid{box-shadow:none}button,input:where([type=button],[type=reset],[type=submit]){appearance:button}::file-selector-button{appearance:button}::-webkit-inner-spin-button{height:auto}::-webkit-outer-spin-button{height:auto}[hidden]:where(:not([hidden=until-found])){display:none!important}}@layer components;@layer utilities{.db\\:absolute{position:absolute}.db\\:relative{position:relative}.db\\:m-0{margin:calc(var(--db-spacing)*0)}.db\\:mt-\\[-5px\\]{margin-top:-5px}.db\\:mt-\\[2px\\]{margin-top:2px}.db\\:ml-auto{margin-left:auto}.db\\:flex{display:flex}.db\\:hidden{display:none}.db\\:h-\\[24px\\]{height:24px}.db\\:h-\\[35px\\]{height:35px}.db\\:h-\\[40px\\]{height:40px}.db\\:h-\\[105px\\]{height:105px}.db\\:h-fit{height:fit-content}.db\\:h-full{height:100%}.db\\:w-\\[20px\\]{width:20px}.db\\:w-\\[24px\\]{width:24px}.db\\:w-\\[35px\\]{width:35px}.db\\:w-\\[165px\\]{width:165px}.db\\:w-full{width:100%}.db\\:w-max{width:max-content}.db\\:max-w-\\[150px\\]{max-width:150px}.db\\:translate-x-\\[-140px\\]{--tw-translate-x:-140px;translate:var(--tw-translate-x)var(--tw-translate-y)}.db\\:translate-y-\\[5px\\]{--tw-translate-y:5px;translate:var(--tw-translate-x)var(--tw-translate-y)}.db\\:rotate-\\[180deg\\]{rotate:180deg}.db\\:cursor-pointer{cursor:pointer}.db\\:flex-col{flex-direction:column}.db\\:flex-row{flex-direction:row}.db\\:items-center{align-items:center}.db\\:justify-between{justify-content:space-between}.db\\:justify-center{justify-content:center}.db\\:gap-2{gap:calc(var(--db-spacing)*2)}.db\\:gap-\\[10px\\]{gap:10px}.db\\:gap-\\[20px\\]{gap:20px}.db\\:rounded-full{border-radius:3.40282e38px}.db\\:border{border-style:var(--tw-border-style);border-width:1px}.db\\:border-0{border-style:var(--tw-border-style);border-width:0}.db\\:border-\\[1\\.5px\\]{border-style:var(--tw-border-style);border-width:1.5px}.db\\:border-b{border-bottom-style:var(--tw-border-style);border-bottom-width:1px}.db\\:border-solid{--tw-border-style:solid;border-style:solid}.db\\:border-\\[\\#999999\\]{border-color:#999}.db\\:border-white{border-color:var(--db-color-white)}.db\\:bg-\\[\\#102039\\]{background-color:#102039}.db\\:bg-\\[\\#ffffff\\]{background-color:#fff}.db\\:bg-\\[var\\(--decibel-player-color\\)\\]{background-color:var(--decibel-player-color)}.db\\:bg-transparent{background-color:#0000}.db\\:p-0{padding:calc(var(--db-spacing)*0)}.db\\:p-2{padding:calc(var(--db-spacing)*2)}.db\\:p-\\[3px\\]{padding:3px}.db\\:p-\\[10px\\]{padding:10px}.db\\:px-\\[5px\\]{padding-inline:5px}.db\\:py-\\[2px\\]{padding-block:2px}.db\\:py-\\[5px\\]{padding-block:5px}.db\\:pt-\\[10px\\]{padding-top:10px}.db\\:pr-\\[12px\\]{padding-right:12px}.db\\:pb-\\[10px\\]{padding-bottom:10px}.db\\:pl-\\[12px\\]{padding-left:12px}.db\\:text-left{text-align:left}.db\\:text-base{font-size:var(--db-text-base);line-height:var(--tw-leading,var(--db-text-base--line-height))}.db\\:text-lg{font-size:var(--db-text-lg);line-height:var(--tw-leading,var(--db-text-lg--line-height))}.db\\:text-xs{font-size:var(--db-text-xs);line-height:var(--tw-leading,var(--db-text-xs--line-height))}.db\\:text-\\[14px\\]{font-size:14px}.db\\:text-\\[16px\\]{font-size:16px}.db\\:leading-\\[24px\\]{--tw-leading:24px;line-height:24px}.db\\:leading-\\[none\\]{--tw-leading:none;line-height:none}.db\\:font-bold{--tw-font-weight:var(--db-font-weight-bold);font-weight:var(--db-font-weight-bold)}.db\\:text-\\[\\#999999\\]{color:#999}.db\\:text-black{color:var(--db-color-black)}.db\\:text-white{color:var(--db-color-white)}.db\\:accent-white{accent-color:var(--db-color-white)}.db\\:\\[writing-mode\\:vertical-lr\\]{writing-mode:vertical-lr}@media (min-width:48rem){.db\\:md\\:block{display:block}}}.oswald{letter-spacing:0;font-family:Oswald,Arial Narrow,Arial,sans-serif}.founders-cond{font-family:FoundersGroteskCond,Arial Narrow,Arial,sans-serif}:root{--decibel-player-color:#2f61ff}.decibel-play,.decibel-pause{fill:var(--decibel-player-color)}@property --tw-translate-x{syntax:"*";inherits:false;initial-value:0}@property --tw-translate-y{syntax:"*";inherits:false;initial-value:0}@property --tw-translate-z{syntax:"*";inherits:false;initial-value:0}@property --tw-border-style{syntax:"*";inherits:false;initial-value:solid}@property --tw-leading{syntax:"*";inherits:false}@property --tw-font-weight{syntax:"*";inherits:false}._scrubber_6vw0o_3{-webkit-appearance:none;appearance:none;width:100%;cursor:pointer;outline:none;height:6px;background:#ccc}._scrubber_6vw0o_3::-webkit-slider-thumb{visibility:hidden}._scrubber_6vw0o_3::-webkit-slider-runnable-track{width:100%;height:4px;cursor:pointer;animate:.2s;border-radius:0}._aiIcon_d70ev_2{width:20px;height:20px;border:solid 1px #ccc}._aiIcon_d70ev_2>svg path{fill:#ccc;transform:scale(1.5) translate(-2.5px,-2px)}._aiIcon_d70ev_2:hover{border:solid 1px #102039;background-color:#102039;transition:all .3s}._popover_d70ev_21{max-width:234px;min-width:150px;translate:-95% 10px;left:100%}._popoverTriangle_d70ev_27{width:0px;height:0px;border-style:solid;border-width:0 7px 8px 7px;border-color:transparent transparent #102039 transparent;position:absolute;right:10px;top:-8px}._popOverInner_d70ev_38{gap:30px}@media screen and (max-width: 768px){._decibelWrapper_obmet_3{flex-direction:column;align-items:flex-start;gap:10px}._ctaWrapper_obmet_8{width:100%;justify-content:space-between}}')),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import { jsx as l, Fragment as be, jsxs as R } from "react/jsx-runtime";
import * as w from "react";
import he, { useState as E, useEffect as N, useId as fe, useRef as I, useCallback as T, useContext as ve, createContext as we, useMemo as ye } from "react";
class ge {
  #e;
  constructor(t) {
    this.#e = t;
  }
  init({ applicationId: t, clientToken: n, env: r, consumer: o }) {
    this.#e.init({
      applicationId: t,
      clientToken: n,
      site: "datadoghq.com",
      service: `decibel-player-${o}`,
      env: r,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20
    });
  }
}
const xe = (e) => /* @__PURE__ */ w.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 71 71", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "decibel-play", ...e }, /* @__PURE__ */ w.createElement("rect", { width: "100%", height: "100%", rx: 35.25 }), /* @__PURE__ */ w.createElement("path", { d: "M27.0849 49.6114V23.5002L49.8803 36.5558L27.0849 49.6114Z", fill: "white" })), Ce = (e) => /* @__PURE__ */ w.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 71 71", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "decibel-pause", ...e }, /* @__PURE__ */ w.createElement("rect", { x: 0.25, y: 0.5, width: "100%", height: "100%", rx: 35.25 }), /* @__PURE__ */ w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32.5833 47.167H25.9167C25.7932 47.167 25.6929 47.1284 25.6157 47.0513C25.5386 46.9741 25.5 46.8738 25.5 46.7503V27.5837C25.5 27.4602 25.5386 27.3599 25.6157 27.2827C25.6929 27.2056 25.7932 27.167 25.9167 27.167H32.5833C32.7068 27.167 32.8071 27.2056 32.8843 27.2827C32.9614 27.3599 33 27.4602 33 27.5837V46.7503C33 46.8738 32.9614 46.9741 32.8843 47.0513C32.8071 47.1284 32.7068 47.167 32.5833 47.167ZM45.0833 47.167H38.4167C38.2932 47.167 38.1929 47.1284 38.1157 47.0513C38.0386 46.9741 38 46.8738 38 46.7503V27.5837C38 27.4602 38.0386 27.3599 38.1157 27.2827C38.1929 27.2056 38.2932 27.167 38.4167 27.167H45.0833C45.2068 27.167 45.3071 27.2056 45.3843 27.2827C45.4614 27.3599 45.5 27.4602 45.5 27.5837V46.7503C45.5 46.8738 45.4614 46.9741 45.3843 47.0513C45.3071 47.1284 45.2068 47.167 45.0833 47.167Z", fill: "white" })), Re = ({ onClick: e, isPlaying: t }) => /* @__PURE__ */ l(
  "button",
  {
    "data-testid": "play-pause-button",
    onClick: e,
    className: "db:w-[35px] db:h-[35px] db:cursor-pointer",
    children: t ? /* @__PURE__ */ l(Ce, { "data-testid": "pause-icon", width: 35, fill: "red" }) : /* @__PURE__ */ l(xe, { "data-testid": "play-icon", width: 35 })
  }
), Se = "_scrubber_6vw0o_3", ke = {
  scrubber: Se
}, _e = ({
  value: e = 0,
  onChange: t,
  reference: n
}) => {
  const r = (o) => {
    t(Number(o.target.value));
  };
  return /* @__PURE__ */ l("div", { className: "scrubber", children: /* @__PURE__ */ l(
    "input",
    {
      className: ke.scrubber,
      ref: n,
      type: "range",
      max: "100",
      min: "0",
      step: 0,
      value: e,
      onInput: r
    }
  ) });
}, Ne = (e) => /* @__PURE__ */ w.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "100%", viewBox: "0 -960 960 960", width: "100%", ...e }, /* @__PURE__ */ w.createElement("path", { fill: "#999999", strokeLinecap: "round", d: "M792-56 671-177q-25 16-53 27.5T560-131v-82q14-5 27.5-10t25.5-12L480-368v208L280-360H120v-240h128L56-792l56-56 736 736-56 56Zm-8-232-58-58q17-31 25.5-65t8.5-70q0-94-55-168T560-749v-82q124 28 202 125.5T840-481q0 53-14.5 102T784-288ZM650-422l-90-90v-130q47 22 73.5 66t26.5 96q0 15-2.5 29.5T650-422ZM480-592 376-696l104-104v208Zm-80 238v-94l-72-72H200v80h114l86 86Zm-36-130Z" })), Pe = (e) => /* @__PURE__ */ w.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 15 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M12.38 1.28667C13.6298 2.53685 14.3319 4.23224 14.3319 6C14.3319 7.76776 13.6298 9.46315 12.38 10.7133M10.0267 3.64C10.6516 4.26509 11.0026 5.11279 11.0026 5.99667C11.0026 6.88055 10.6516 7.72824 10.0267 8.35333M7 1.33333L3.66667 4H1V8H3.66667L7 10.6667V1.33333Z", width: "15px", stroke: "#999999", strokeWidth: 1.33333, strokeLinecap: "round", strokeLinejoin: "round" })), $ = (e) => {
  const [t, n] = E(!1);
  return N(() => {
    const r = (o) => {
      e.current && !e.current.contains(o.target) && n(!1);
    };
    return document.addEventListener("mousedown", r), () => {
      document.removeEventListener("mousedown", r);
    };
  }, [e]), {
    showPopover: t,
    setShowPopover: n
  };
}, Ee = ({ handleVolumeChange: e, volume: t }) => {
  const n = he.useRef(null), { setShowPopover: r, showPopover: o } = $(n);
  return /* @__PURE__ */ l(be, { children: /* @__PURE__ */ R("div", { ref: n, className: "db:hidden db:md:block", children: [
    /* @__PURE__ */ l(
      "button",
      {
        className: "db:p-[3px] db:flex db:items-center db:justify-center db:w-[24px] db:h-[24px] db:border db:border-[1.5px] db:border-solid db:border-[#999999] ",
        type: "button",
        onClick: () => r(!o),
        children: /* @__PURE__ */ l("span", { className: "db:w-[35px] db:h-[35px] db:cursor-pointer", children: t === 0 ? /* @__PURE__ */ l(Ne, {}) : /* @__PURE__ */ l(Pe, {}) })
      }
    ),
    o && /* @__PURE__ */ l("div", { className: "db:absolute db:px-[5px] db:py-[2px] db:h-[105px] db:mt-[2px] db:bg-[var(--decibel-player-color)]", children: /* @__PURE__ */ l("div", { className: "db:flex db:h-full db:py-[5px]", children: /* @__PURE__ */ l(
      "input",
      {
        className: "db:rotate-[180deg] db:accent-white db:[writing-mode:vertical-lr]",
        type: "range",
        min: "0",
        max: "1",
        step: "0.01",
        onChange: (i) => e(parseFloat(i.target.value)),
        value: t
      }
    ) }) })
  ] }) });
}, Ie = (e) => /* @__PURE__ */ w.createElement("svg", { width: 12, height: 9, viewBox: "0 0 12 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.0791 1.0876C11.307 1.31541 11.307 1.68475 11.0791 1.91256L4.66248 8.32923C4.43467 8.55703 4.06533 8.55703 3.83752 8.32923L0.920854 5.41256C0.693049 5.18475 0.693049 4.81541 0.920854 4.5876C1.14866 4.3598 1.51801 4.3598 1.74581 4.5876L4.25 7.09179L10.2542 1.0876C10.482 0.859797 10.8513 0.859797 11.0791 1.0876Z", fill: "white" })), q = ({
  value: e,
  currentRate: t,
  handleSpeedChange: n
}) => /* @__PURE__ */ R(
  "button",
  {
    className: "db:h-[40px] db:w-full db:text-white db:text-base db:leading-[none] db:flex db:flex-row db:pl-[12px] db:pr-[12px] db:items-center db:pt-[10px] db:pb-[10px]",
    value: e,
    onClick: () => n(e),
    children: [
      t === e ? /* @__PURE__ */ l(Ie, { className: "db:h-[40px]" }) : /* @__PURE__ */ l("span", { className: "db:h-[40px]" }),
      e,
      "x"
    ]
  }
), se = (e) => /* @__PURE__ */ w.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M18 6L6 18M6 6L18 18", stroke: "white", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })), Me = ({
  jwPlayerRef: e,
  trackAction: t
}) => {
  const n = fe(), r = I(null), { setShowPopover: o, showPopover: s } = $(r), i = () => {
    r.current && o(!1);
  }, d = (y) => {
    e.setPlaybackRate(isNaN(y) ? 1 : y), t(y), i();
  }, c = e?.getPlaybackRate();
  return /* @__PURE__ */ R("div", { ref: r, children: [
    /* @__PURE__ */ R(
      "button",
      {
        className: "db:w-[35px] db:h-[24px] db:border db:border-[1.5px] db:border-solid db:border-[#999999] db:text-[#999999] db:bg-[#ffffff]  db:cursor-pointer db:text-[16px] db:leading-[24px] db:flex db:items-center db:justify-center",
        type: "button",
        onClick: () => o(!s),
        children: [
          c,
          "x"
        ]
      }
    ),
    s && /* @__PURE__ */ R(
      "div",
      {
        className: "db:translate-x-[-140px] db:translate-y-[5px] db:absolute db:border-0 db:p-0 db:m-0 db:w-[165px] db:bg-[var(--decibel-player-color)]",
        id: n,
        children: [
          /* @__PURE__ */ R("div", { className: "db:flex db:text-white db:flex-row db:justify-between db:p-[10px] db:border-white db:border-solid db:border-b", children: [
            /* @__PURE__ */ l("div", { className: "f3 fw3", children: "Playback Speed" }),
            /* @__PURE__ */ l(
              "button",
              {
                type: "button",
                title: "Close",
                onClick: () => o(!s),
                children: /* @__PURE__ */ l(se, { className: "db" })
              }
            )
          ] }),
          /* @__PURE__ */ R("div", { children: [
            /* @__PURE__ */ l(
              q,
              {
                value: 1,
                currentRate: c,
                handleSpeedChange: d
              }
            ),
            /* @__PURE__ */ l(
              q,
              {
                value: 1.5,
                currentRate: c,
                handleSpeedChange: d
              }
            ),
            /* @__PURE__ */ l(
              q,
              {
                value: 1.75,
                currentRate: c,
                handleSpeedChange: d
              }
            ),
            /* @__PURE__ */ l(
              q,
              {
                value: 2,
                currentRate: c,
                handleSpeedChange: d
              }
            )
          ] })
        ]
      }
    )
  ] });
}, W = {
  IN_VIEW: "decibel_player_inview",
  CLICK: "decibel_player_click",
  ACTION: "decibel_player_action"
}, Te = (e, t) => {
  const n = T(() => {
    e && [
      W.IN_VIEW,
      W.CLICK,
      W.ACTION
    ].forEach((r) => {
      e("register", r, {
        allowDuplicate: !0,
        consumer: t?.consumer || "decibel",
        variant: t?.trackingVariant || "no variant"
      });
    });
  }, [e]);
  return N(() => {
    if (!e) {
      console.log("no tracking");
      return;
    }
    console.log("Tracking"), n();
  }, [n, e]), {
    /**
     * Track when the player is in view.
     * @param placement - The placement of the player (e.g., 'mobile', 'tablet', 'desktop').
     * @returns nothing
     */
    trackInView: (r) => {
      if (!e) {
        console.log("no tracking");
        return;
      }
      e("track", "decibel_player_inview", {
        consumer: t?.consumer || "decibel",
        variant: t?.trackingVariant || "no variant",
        placement: r
      });
    },
    /**
     * Track a click event on the player.
     * @returns nothing
     */
    trackClick: () => {
      if (!e) {
        console.log("no tracking");
        return;
      }
      e("track", "decibel_player_click", {
        consumer: t?.consumer || "decibel",
        variant: t?.trackingVariant || "no variant"
      });
    },
    /**
     *
     * @param actionName
     * @param trackingData Can be any additional data you want to track with the action
     * @returns nothing
     */
    trackAction: T(
      (r, o) => {
        if (!e) {
          console.log("no tracking");
          return;
        }
        e("track", "decibel_player_action", {
          action: r,
          consumer: t?.consumer || "decibel",
          variant: t?.trackingVariant || "no variant",
          ...o,
          segment: t?.segment || "default"
        });
      },
      [t, e]
    )
  };
};
var K = /* @__PURE__ */ new Map(), V = /* @__PURE__ */ new WeakMap(), X = 0, Le = void 0;
function Oe(e) {
  return e ? (V.has(e) || (X += 1, V.set(e, X.toString())), V.get(e)) : "0";
}
function qe(e) {
  return Object.keys(e).sort().filter(
    (t) => e[t] !== void 0
  ).map((t) => `${t}_${t === "root" ? Oe(e.root) : e[t]}`).toString();
}
function Ve(e) {
  const t = qe(e);
  let n = K.get(t);
  if (!n) {
    const r = /* @__PURE__ */ new Map();
    let o;
    const s = new IntersectionObserver((i) => {
      i.forEach((d) => {
        var c;
        const y = d.isIntersecting && o.some((a) => d.intersectionRatio >= a);
        e.trackVisibility && typeof d.isVisible > "u" && (d.isVisible = y), (c = r.get(d.target)) == null || c.forEach((a) => {
          a(y, d);
        });
      });
    }, e);
    o = s.thresholds || (Array.isArray(e.threshold) ? e.threshold : [e.threshold || 0]), n = {
      id: t,
      observer: s,
      elements: r
    }, K.set(t, n);
  }
  return n;
}
function je(e, t, n = {}, r = Le) {
  if (typeof window.IntersectionObserver > "u" && r !== void 0) {
    const c = e.getBoundingClientRect();
    return t(r, {
      isIntersecting: r,
      target: e,
      intersectionRatio: typeof n.threshold == "number" ? n.threshold : 0,
      time: 0,
      boundingClientRect: c,
      intersectionRect: c,
      rootBounds: c
    }), () => {
    };
  }
  const { id: o, observer: s, elements: i } = Ve(n), d = i.get(e) || [];
  return i.has(e) || i.set(e, d), d.push(t), s.observe(e), function() {
    d.splice(d.indexOf(t), 1), d.length === 0 && (i.delete(e), s.unobserve(e)), i.size === 0 && (s.disconnect(), K.delete(o));
  };
}
function We({
  threshold: e,
  delay: t,
  trackVisibility: n,
  rootMargin: r,
  root: o,
  triggerOnce: s,
  skip: i,
  initialInView: d,
  fallbackInView: c,
  onChange: y
} = {}) {
  var a;
  const [u, b] = w.useState(null), h = w.useRef(y), [C, v] = w.useState({
    inView: !!d,
    entry: void 0
  });
  h.current = y, w.useEffect(
    () => {
      if (i || !u) return;
      let f;
      return f = je(
        u,
        (x, M) => {
          v({
            inView: x,
            entry: M
          }), h.current && h.current(x, M), M.isIntersecting && s && f && (f(), f = void 0);
        },
        {
          root: o,
          rootMargin: r,
          threshold: e,
          // @ts-ignore
          trackVisibility: n,
          // @ts-ignore
          delay: t
        },
        c
      ), () => {
        f && f();
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(e) ? e.toString() : e,
      u,
      o,
      r,
      s,
      i,
      n,
      c,
      t
    ]
  );
  const _ = (a = C.entry) == null ? void 0 : a.target, P = w.useRef(void 0);
  !u && _ && !s && !i && P.current !== _ && (P.current = _, v({
    inView: !!d,
    entry: void 0
  }));
  const S = [b, C.inView, C.entry];
  return S.ref = S[0], S.inView = S[1], S.entry = S[2], S;
}
const He = (e) => /* @__PURE__ */ w.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ w.createElement("path", { d: "M9.51232 7.9188H11.4861V14.75H9.51232V7.9188ZM9.51232 7.0861V5.1894H11.4861V7.0861H9.51232Z", fill: "white" })), Ae = "_aiIcon_d70ev_2", De = "_popover_d70ev_21", Ze = "_popoverTriangle_d70ev_27", H = {
  aiIcon: Ae,
  popover: De,
  popoverTriangle: Ze
};
function G(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var A = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Y;
function Fe() {
  return Y || (Y = 1, (function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var s = "", i = 0; i < arguments.length; i++) {
          var d = arguments[i];
          d && (s = o(s, r(d)));
        }
        return s;
      }
      function r(s) {
        if (typeof s == "string" || typeof s == "number")
          return s;
        if (typeof s != "object")
          return "";
        if (Array.isArray(s))
          return n.apply(null, s);
        if (s.toString !== Object.prototype.toString && !s.toString.toString().includes("[native code]"))
          return s.toString();
        var i = "";
        for (var d in s)
          t.call(s, d) && s[d] && (i = o(i, d));
        return i;
      }
      function o(s, i) {
        return i ? s ? s + " " + i : s + i : s;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  })(A)), A.exports;
}
var Qe = Fe();
const L = /* @__PURE__ */ G(Qe), Ue = ({
  disclaimerText: e
}) => {
  const t = I(null), { showPopover: n, setShowPopover: r } = $(t), o = () => {
    r(!n);
  };
  return /* @__PURE__ */ R("div", { className: "db:relative", children: [
    /* @__PURE__ */ l(
      "button",
      {
        type: "button",
        className: L(
          H.aiIcon,
          "db:mt-[2px] db:rounded-full db:flex db:items-center db:justify-center db:cursor-pointer"
        ),
        onClick: o,
        children: /* @__PURE__ */ l(He, { width: 25 })
      }
    ),
    n && /* @__PURE__ */ l(
      "div",
      {
        ref: t,
        className: L(
          H.popover,
          "db:flex db:flex-col db:items-center db:justify-center db:absolute db:bg-[#102039]"
        ),
        children: /* @__PURE__ */ R("div", { className: "db:flex db:gap-[10px] db:p-[10px]  db:w-full", children: [
          /* @__PURE__ */ R(
            "div",
            {
              className: L(
                "db:flex db:text-left db:text-xs  db:text-white db:justify-between  db:w-full "
              ),
              children: [
                /* @__PURE__ */ l("div", { className: H.popoverTriangle }),
                /* @__PURE__ */ l("span", { children: e })
              ]
            }
          ),
          /* @__PURE__ */ l(
            "button",
            {
              type: "button",
              className: "db:w-[20px] db:h-fit db:rounded-full db:bg-transparent db:cursor-pointer",
              onClick: o,
              children: /* @__PURE__ */ l(se, {})
            }
          )
        ] })
      }
    )
  ] });
}, Be = "_decibelWrapper_obmet_3", Ke = "_ctaWrapper_obmet_8", z = {
  decibelWrapper: Be,
  ctaWrapper: Ke
};
var j = {}, J;
function $e() {
  if (J) return j;
  J = 1, j.match = s, j.parse = i;
  var e = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, t = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, n = /^(?:(min|max)-)?(.+)/, r = /(em|rem|px|cm|mm|in|pt|pc)?$/, o = /(dpi|dpcm|dppx)?$/;
  function s(a, u) {
    return i(a).some(function(b) {
      var h = b.inverse, C = b.type === "all" || u.type === b.type;
      if (C && h || !(C || h))
        return !1;
      var v = b.expressions.every(function(_) {
        var P = _.feature, S = _.modifier, f = _.value, x = u[P];
        if (!x)
          return !1;
        switch (P) {
          case "orientation":
          case "scan":
            return x.toLowerCase() === f.toLowerCase();
          case "width":
          case "height":
          case "device-width":
          case "device-height":
            f = y(f), x = y(x);
            break;
          case "resolution":
            f = c(f), x = c(x);
            break;
          case "aspect-ratio":
          case "device-aspect-ratio":
          case /* Deprecated */
          "device-pixel-ratio":
            f = d(f), x = d(x);
            break;
          case "grid":
          case "color":
          case "color-index":
          case "monochrome":
            f = parseInt(f, 10) || 1, x = parseInt(x, 10) || 0;
            break;
        }
        switch (S) {
          case "min":
            return x >= f;
          case "max":
            return x <= f;
          default:
            return x === f;
        }
      });
      return v && !h || !v && h;
    });
  }
  function i(a) {
    return a.split(",").map(function(u) {
      u = u.trim();
      var b = u.match(e), h = b[1], C = b[2], v = b[3] || "", _ = {};
      return _.inverse = !!h && h.toLowerCase() === "not", _.type = C ? C.toLowerCase() : "all", v = v.match(/\([^\)]+\)/g) || [], _.expressions = v.map(function(P) {
        var S = P.match(t), f = S[1].toLowerCase().match(n);
        return {
          modifier: f[1],
          feature: f[2],
          value: S[2]
        };
      }), _;
    });
  }
  function d(a) {
    var u = Number(a), b;
    return u || (b = a.match(/^(\d+)\s*\/\s*(\d+)$/), u = b[1] / b[2]), u;
  }
  function c(a) {
    var u = parseFloat(a), b = String(a).match(o)[1];
    switch (b) {
      case "dpcm":
        return u / 2.54;
      case "dppx":
        return u * 96;
      default:
        return u;
    }
  }
  function y(a) {
    var u = parseFloat(a), b = String(a).match(r)[1];
    switch (b) {
      case "em":
        return u * 16;
      case "rem":
        return u * 16;
      case "cm":
        return u * 96 / 2.54;
      case "mm":
        return u * 96 / 2.54 / 10;
      case "in":
        return u * 96;
      case "pt":
        return u * 72;
      case "pc":
        return u * 72 / 12;
      default:
        return u;
    }
  }
  return j;
}
var D, ee;
function Ge() {
  if (ee) return D;
  ee = 1;
  var e = $e().match, t = typeof window < "u" ? window.matchMedia : null;
  function n(o, s, i) {
    var d = this, c;
    t && !i && (c = t.call(window, o)), c ? (this.matches = c.matches, this.media = c.media, c.addListener(u)) : (this.matches = e(o, s), this.media = o), this.addListener = y, this.removeListener = a, this.dispose = b;
    function y(h) {
      c && c.addListener(h);
    }
    function a(h) {
      c && c.removeListener(h);
    }
    function u(h) {
      d.matches = h.matches, d.media = h.media;
    }
    function b() {
      c && c.removeListener(u);
    }
  }
  function r(o, s, i) {
    return new n(o, s, i);
  }
  return D = r, D;
}
var Xe = Ge();
const Ye = /* @__PURE__ */ G(Xe);
var ze = /[A-Z]/g, Je = /^ms-/, Z = {};
function et(e) {
  return "-" + e.toLowerCase();
}
function ie(e) {
  if (Z.hasOwnProperty(e))
    return Z[e];
  var t = e.replace(ze, et);
  return Z[e] = Je.test(t) ? "-" + t : t;
}
function tt(e, t) {
  if (e === t)
    return !0;
  if (!e || !t)
    return !1;
  const n = Object.keys(e), r = Object.keys(t), o = n.length;
  if (r.length !== o)
    return !1;
  for (let s = 0; s < o; s++) {
    const i = n[s];
    if (e[i] !== t[i] || !Object.prototype.hasOwnProperty.call(t, i))
      return !1;
  }
  return !0;
}
var F = { exports: {} }, Q, te;
function rt() {
  if (te) return Q;
  te = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Q = e, Q;
}
var U, re;
function nt() {
  if (re) return U;
  re = 1;
  var e = /* @__PURE__ */ rt();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, U = function() {
    function r(i, d, c, y, a, u) {
      if (u !== e) {
        var b = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw b.name = "Invariant Violation", b;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var s = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return s.PropTypes = s, s;
  }, U;
}
var ne;
function ot() {
  return ne || (ne = 1, F.exports = /* @__PURE__ */ nt()()), F.exports;
}
var st = /* @__PURE__ */ ot();
const m = /* @__PURE__ */ G(st), k = m.oneOfType([m.string, m.number]), ae = {
  all: m.bool,
  grid: m.bool,
  aural: m.bool,
  braille: m.bool,
  handheld: m.bool,
  print: m.bool,
  projection: m.bool,
  screen: m.bool,
  tty: m.bool,
  tv: m.bool,
  embossed: m.bool
}, it = {
  orientation: m.oneOf(["portrait", "landscape"]),
  scan: m.oneOf(["progressive", "interlace"]),
  aspectRatio: m.string,
  deviceAspectRatio: m.string,
  height: k,
  deviceHeight: k,
  width: k,
  deviceWidth: k,
  color: m.bool,
  colorIndex: m.bool,
  monochrome: m.bool,
  resolution: k,
  type: Object.keys(ae)
}, { type: St, ...at } = it, ct = {
  minAspectRatio: m.string,
  maxAspectRatio: m.string,
  minDeviceAspectRatio: m.string,
  maxDeviceAspectRatio: m.string,
  minHeight: k,
  maxHeight: k,
  minDeviceHeight: k,
  maxDeviceHeight: k,
  minWidth: k,
  maxWidth: k,
  minDeviceWidth: k,
  maxDeviceWidth: k,
  minColor: m.number,
  maxColor: m.number,
  minColorIndex: m.number,
  maxColorIndex: m.number,
  minMonochrome: m.number,
  maxMonochrome: m.number,
  minResolution: k,
  maxResolution: k,
  ...at
}, lt = { ...ae, ...ct };
var dt = {
  all: lt
};
const ut = (e) => `not ${e}`, pt = (e, t) => {
  const n = ie(e);
  return typeof t == "number" && (t = `${t}px`), t === !0 ? n : t === !1 ? ut(n) : `(${n}: ${t})`;
}, mt = (e) => e.join(" and "), bt = (e) => {
  const t = [];
  return Object.keys(dt.all).forEach((n) => {
    const r = e[n];
    r != null && t.push(pt(n, r));
  }), mt(t);
}, ht = we(void 0), ft = (e) => e.query || bt(e), oe = (e) => e ? Object.keys(e).reduce((n, r) => (n[ie(r)] = e[r], n), {}) : void 0, ce = () => {
  const e = I(!1);
  return N(() => {
    e.current = !0;
  }, []), e.current;
}, vt = (e) => {
  const t = ve(ht), n = () => oe(e) || oe(t), [r, o] = E(n);
  return N(() => {
    const s = n();
    tt(r, s) || o(s);
  }, [e, t]), r;
}, wt = (e) => {
  const t = () => ft(e), [n, r] = E(t);
  return N(() => {
    const o = t();
    n !== o && r(o);
  }, [e]), n;
}, yt = (e, t) => {
  const n = () => Ye(e, t || {}, !!t), [r, o] = E(n), s = ce();
  return N(() => {
    if (s) {
      const i = n();
      return o(i), () => {
        i && i.dispose();
      };
    }
  }, [e, t]), r;
}, gt = (e) => {
  const [t, n] = E(e.matches);
  return N(() => {
    const r = (o) => {
      n(o.matches);
    };
    return e.addListener(r), n(e.matches), () => {
      e.removeListener(r);
    };
  }, [e]), t;
}, B = (e, t, n) => {
  const r = vt(t), o = wt(e);
  if (!o)
    throw new Error("Invalid or missing MediaQuery!");
  const s = yt(o, r), i = gt(s);
  return ce(), N(() => {
  }, [i]), N(() => () => {
    s && s.dispose();
  }, []), i;
}, xt = {
  progress: 0,
  currentTime: "00:00",
  duration: "00:00",
  volume: 0.5,
  isPlaying: !1
}, kt = ({
  file: e,
  env: t = "development",
  rum: n,
  $t: r,
  baseTrackingData: o = {
    consumer: "decibel",
    trackingVariant: "default",
    segment: "default",
    guid: "",
    date: /* @__PURE__ */ new Date()
  },
  callToAction: s,
  disclaimerText: i
}) => {
  const d = n ? new ge(n) : null, c = I(null), y = I(null), [a, u] = E(null), b = I(null), [h, C] = E(xt), { trackAction: v, trackInView: _ } = Te(
    r,
    o
  ), P = B({ query: "(max-width: 767px)" }), S = B({
    query: "(min-width: 768px) and (max-width: 999px)"
  }), f = B({ query: "(min-width: 1000px)" }), x = ye(() => P ? "mobile" : S ? "tablet" : "desktop", [P, S, f]), { ref: M } = We({
    triggerOnce: !0,
    onChange: (p) => {
      p && _(x);
    }
  });
  N(() => {
    v("init", o), d && d.init({
      applicationId: "c77d6aa4-a8df-43c5-b0d3-2cc9c709a5ca",
      clientToken: "pubc2e808db6db8d26afefdbf5ddff7d087",
      env: t,
      consumer: o?.consumer
    });
    const p = document.createElement("script");
    return p.src = "https://nodeassets.nbcnews.com/jwplayer/jwplayer-8.30.1/jwplayer.js", p.async = !0, p.onload = () => {
      c.current && window.jwplayer && (window.jwplayer(c.current.id).setup({
        file: e,
        height: "30px",
        // jwPlayer needs a minimium height of 30px
        key: "+9o3ihbMIU8/ixFry35xlHnkQ9tikKg9TU0io1QbWXfpeR0q"
      }), u(window.jwplayer(c.current.id)));
    }, document.body.appendChild(p), () => {
      document.body.contains(p) && document.body.removeChild(p), c.current && window.jwplayer && window.jwplayer(c.current.id) && window.jwplayer(c.current.id).remove();
    };
  }, []);
  const le = (p) => {
    const O = p / 100 * 100;
    y.current && (y.current.style.background = `linear-gradient(to right, var(--decibel-player-color) ${O}%, #ccc ${O}%)`);
  };
  N(() => !a || !h.isPlaying ? () => {
    b.current && clearInterval(b.current);
  } : (b.current = setInterval(() => {
    v("time_spent", {
      secondsElapsed: 3,
      playheadPosition: a.getPosition() || 0
    });
  }, 3e3), () => {
    b.current && clearInterval(b.current);
  }), [h.isPlaying]);
  const de = () => {
    a && (h.isPlaying ? a.pause() : a.play());
  }, ue = T(
    (p) => {
      const g = p / 100;
      a && (a.seek((a.getDuration() || 0) * g), v("progress_bar", {
        time: (a.getDuration() || 0) * g || 0,
        playheadPosition: a.getPosition() || 0
      }));
    },
    [a, v]
  ), pe = T(
    (p) => {
      const g = p * 100;
      a && (a.setVolume(g), v("volume_change", {
        volumeLevel: g
      }));
    },
    [a, v]
  ), me = T(
    (p) => {
      v("playback_speed", {
        speed: p
      });
    },
    [e, v]
  );
  return N(() => {
    a && (a.on("meta", (p) => {
      C((g) => ({
        ...g,
        progress: 0,
        duration: new Date(p.duration * 1e3).toISOString().slice(14, 19)
      }));
    }), a.on("time", (p) => {
      const g = p.currentTime / p.duration * 100;
      C((O) => ({
        ...O,
        progress: g,
        duration: new Date(p.duration * 1e3).toISOString().slice(14, 19),
        currentTime: new Date(p.currentTime * 1e3).toISOString().slice(14, 19)
      })), le(g);
    }), a.on("volume", (p) => {
      C((g) => ({
        ...g,
        volume: p.volume / 100
      }));
    }), a.on("play", (p) => {
      C((g) => ({
        ...g,
        volume: p.volume / 100,
        isPlaying: !0
      })), v("play", {
        action: "play"
      });
    }), a.on("pause", (p) => {
      C((g) => ({
        ...g,
        volume: p.volume / 100,
        isPlaying: !1
      })), v("pause", {
        action: "pause"
      });
    }), a.on("complete", (p) => {
      C((g) => ({
        ...g,
        volume: p.volume / 100,
        isPlaying: !1
      })), v("complete", {
        action: "completed"
      }), a.stop();
    }));
  }, [a]), /* @__PURE__ */ l(
    "div",
    {
      className: "db:text-[14px] db:p-2 db:flex db:items-center db:flex-col oswald ",
      "data-testid": "decibel-component",
      ref: M,
      children: /* @__PURE__ */ R(
        "div",
        {
          className: L(
            z.decibelWrapper,
            "db:flex db:w-full db:gap-[20px]"
          ),
          children: [
            /* @__PURE__ */ R(
              "div",
              {
                className: L(
                  z.ctaWrapper,
                  "db:flex db:font-bold db:items-center db:gap-[10px]"
                ),
                children: [
                  /* @__PURE__ */ l("div", { className: "db:max-w-[150px] db:w-max db:text-lg founders-cond", children: s }),
                  i && /* @__PURE__ */ l(Ue, { disclaimerText: i })
                ]
              }
            ),
            /* @__PURE__ */ l("div", { className: "db:hidden", "data-testid": "decibel-jw-player-container", children: /* @__PURE__ */ l("div", { id: "decibel-jw-player", ref: c }) }),
            /* @__PURE__ */ R("div", { className: "db:flex db:items-center db:gap-2 db:w-full", children: [
              /* @__PURE__ */ l(Re, { onClick: de, isPlaying: h.isPlaying }),
              /* @__PURE__ */ R("div", { className: "db:w-full db:mt-[-5px]", children: [
                /* @__PURE__ */ l(
                  _e,
                  {
                    reference: y,
                    value: h.progress,
                    onChange: ue,
                    max: 100
                  }
                ),
                /* @__PURE__ */ R("div", { className: "db:flex db:justify-between db:items-center db:mt-[-5px] db:text-black", children: [
                  /* @__PURE__ */ l("span", { children: h.currentTime }),
                  /* @__PURE__ */ l("span", { children: h.duration })
                ] })
              ] }),
              /* @__PURE__ */ R("div", { className: "db:flex db:items-center db:gap-2 db:ml-auto", children: [
                /* @__PURE__ */ l(
                  Ee,
                  {
                    handleVolumeChange: pe,
                    volume: h.volume
                  }
                ),
                a && /* @__PURE__ */ l(
                  Me,
                  {
                    jwPlayerRef: a,
                    trackAction: me
                  }
                )
              ] })
            ] })
          ]
        }
      )
    }
  );
};
export {
  kt as Decibel
};
